import { render, staticRenderFns } from "./navAndSide.vue?vue&type=template&id=57508c82&scoped=true&"
import script from "./navAndSide.vue?vue&type=script&lang=js&"
export * from "./navAndSide.vue?vue&type=script&lang=js&"
import style0 from "./navAndSide.vue?vue&type=style&index=0&id=57508c82&prod&lang=css&"
import style1 from "./navAndSide.vue?vue&type=style&index=1&id=57508c82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57508c82",
  null
  
)

export default component.exports